import { render, staticRenderFns } from "./ProfileEdit.vue?vue&type=template&id=3b31132b&scoped=true"
import script from "./ProfileEdit.vue?vue&type=script&lang=js"
export * from "./ProfileEdit.vue?vue&type=script&lang=js"
import style0 from "./ProfileEdit.vue?vue&type=style&index=0&id=3b31132b&prod&lang=scss&scoped=true"
import style1 from "./ProfileEdit.vue?vue&type=style&index=1&id=3b31132b&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b31132b",
  null
  
)

export default component.exports